export enum CustodialAccountRequestStatus {
    NeedMoreInfo = 'Need More Info',
}
